import photo from "../photos/Stuart_Distant_Stare.jpg";

function Hero() {
  return (
    <section className="flex sm:flex-col items-center justify-center bg-blue-600 text-white py-20">
      {/* Photo Section */}
      <div className="mx-10">
        <img
          src={photo} // Replace with the actual path to the photo
          alt="Stuart Hillier"
          className="w-40 h-40 sm:w-56 sm:h-56 rounded-full mx-auto border-4 border-white shadow-lg"
        />
      </div>

      {/* Text Section */}
      <div className="flex flex-col sm:text-center gap-4 p-4">
        <h2 className="text-4xl font-bold">Stuart Hillier</h2>
        <p className="text-xl leading-relaxed">
          Aspiring Lawyer | BAR Certified | Dedicated to Justice
        </p>
        <a
          href="#contact"
          className="lg:w-40 text-center px-6 py-3 bg-white text-blue-600 rounded-lg font-semibold shadow-lg hover:bg-gray-100 hover:shadow-xl transition duration-200"
        >
          Get in Touch
        </a>
      </div>
    </section>
  );
}

export default Hero;
